import { IEditField } from './formTools';
import React from 'react';
import { ITaskEditFormDisplayProps } from './TaskEditForm';
import { EditTimeField, TimeDisplay } from './EditTime';

export const EditCompletedAtTimeDisplay: React.FC<ITaskEditFormDisplayProps> = ({ task, setIsEditing }) => {
  return <TimeDisplay task={task} setIsEditing={setIsEditing} fieldName="completedAt" />;
};

export const EditCompletedAtTimeField: React.FC<IEditField> = ({ submitOnChange, cancel }) => {
  return <EditTimeField submitOnChange={submitOnChange} cancel={cancel} fieldName="completedAt" />;
};
